import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "d-flex align-center justify-start ml-5" }
const _hoisted_3 = {
  class: "ml-2",
  style: {"font-weight":"bold","font-size":"14pt","text-transform":"capitalize"}
}
const _hoisted_4 = {
  key: 0,
  class: "ml-2 mt-1",
  style: {"font-size":"10pt","color":"#5fc9b8"}
}
const _hoisted_5 = {
  key: 1,
  class: "ml-2 mt-1",
  style: {"font-size":"10pt","color":"#f76631"}
}
const _hoisted_6 = {
  class: "ml-2",
  style: {"font-size":"10pt"}
}
const _hoisted_7 = { style: {"font-size":"11pt"} }
const _hoisted_8 = { style: {"font-size":"11pt"} }
const _hoisted_9 = { style: {"font-weight":"bold","font-size":"12pt","color":"#5fc9b8"} }
const _hoisted_10 = { style: {"font-weight":"bold","font-size":"12pt","color":"#f76631"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_oss_card = _resolveComponent("oss-card")!
  const _component_CheckBilanZTillWizard = _resolveComponent("CheckBilanZTillWizard")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_row, {
          class: "d-flex justify-center py-1",
          "no-gutters": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: _ctx.$vuetify.display.mobile ? '12' : '12',
              class: "pa-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { "no-gutters": "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '1'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_v_btn_back, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["cols"]),
                    _createVNode(_component_v_col, {
                      cols: _ctx.$vuetify.display.mobile ? '12' : '8'
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("h1", { class: "ml-2 d-flex justify-start align-center" }, " Bilan mensuel des Z de caisses ", -1)
                      ])),
                      _: 1
                    }, 8, ["cols"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["cols"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, { class: "d-flex justify-center py-1" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "3" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_v_select, {
                  modelValue: _ctx.accountingPeriod,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accountingPeriod) = $event)),
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.accountingPeriodChange()))
                  ],
                  items: _ctx.accountingPeriods,
                  label: "Exercice comptable",
                  "item-title": _ctx.computeAccountingPeriodText,
                  "item-value": "id",
                  "return-object": "",
                  rounded: "",
                  readonly: !_ctx.accountingPeriods || _ctx.accountingPeriods.length === 1
                }, null, 8, ["modelValue", "items", "item-title", "readonly"]), [
                  [_vShow, true]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
          return (_openBlock(), _createBlock(_component_v_row, {
            key: month.name,
            class: "d-flex justify-center py-1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: _ctx.$vuetify.display.mobile ? '12' : '8',
                class: "pa-0 d-flex justify-center",
                style: {"cursor":"pointer"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_oss_card, {
                    icon: 'trending_up',
                    "icon-color": 'secondary'
                  }, {
                    left: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        onClick: ($event: any) => (_ctx.openZtillCalendar(month))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_3, _toDisplayString(month.name), 1),
                                      (
                                                    month.diffAmount >= 0 &&
                                                    month.diffAmount != null
                                                )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (+" + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        month.diffAmount,
                                                        undefined,
                                                    )) + ") ", 1))
                                        : (
                                                    month.diffAmount < 0 && month.diffAmount != null
                                                )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        month.diffAmount,
                                                        undefined,
                                                    )) + ") ", 1))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              (month.warning && month.auditCheckStatus !== 'IGNORE')
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    "no-gutters": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_6, [
                                            _createVNode(_component_v_icon, { color: "warning" }, {
                                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode("$warning")
                                              ])),
                                              _: 1
                                            }),
                                            _cache[6] || (_cache[6] = _createTextVNode(" Z de caisse(s) manquant(s) "))
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                class: "mr-5 d-flex align-center justify-end",
                                "no-gutters": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex align-center justify-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_7, " HT : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        month.netAmount,
                                                        undefined,
                                                    )), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_row, {
                                class: "mr-5 d-flex align-center justify-end",
                                "no-gutters": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "d-flex align-center justify-end"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_8, " TVA : " + _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        month.vatAmount,
                                                        undefined,
                                                    )), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    right: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { style: {} }, {
                            default: _withCtx(() => [
                              (month.grossAmount !== 0)
                                ? (_openBlock(), _createBlock(_component_v_row, {
                                    key: 0,
                                    class: "d-flex justify-center",
                                    "no-gutters": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        month.grossAmount,
                                                        undefined,
                                                    )), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_v_row, {
                                    key: 1,
                                    class: "d-flex justify-center",
                                    "no-gutters": ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "12" }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                        month.grossAmount,
                                                        undefined,
                                                    )), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)),
                              _createVNode(_component_v_row, {
                                class: "d-flex justify-center",
                                "no-gutters": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        "hide-details": true,
                                        outlined: true,
                                        rounded: "",
                                        class: "elevation-0",
                                        onClick: ($event: any) => (_ctx.openZtillCalendar(month))
                                      }, {
                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                          _createTextVNode("Détails ")
                                        ])),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      (month.auditCheckStatus !== 'IGNORE')
                                        ? (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 0,
                                            "hide-details": true,
                                            outlined: true,
                                            rounded: "",
                                            onClick: _withModifiers(($event: any) => (_ctx.ignoreCheck(month)), ["stop"]),
                                            class: "elevation-0 mt-1",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                              _createTextVNode(" Ignorer ")
                                            ])),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (_openBlock(), _createBlock(_component_v_btn, {
                                            key: 1,
                                            "hide-details": true,
                                            outlined: true,
                                            rounded: "",
                                            onClick: _withModifiers(($event: any) => (_ctx.ignoreCheck(month)), ["stop"]),
                                            class: "elevation-0 mt-1",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                              _createTextVNode(" Rétablir ")
                                            ])),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["cols"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      (_ctx.openCalendar)
        ? (_openBlock(), _createBlock(_component_CheckBilanZTillWizard, {
            key: 0,
            active: _ctx.openCalendar,
            "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.openCalendar) = $event)),
            companyId: _ctx.companyId,
            inGlobalStep: 'ztillCalendar',
            dayCalendarStart: _ctx.dayCalendarStart,
            dayCalendarEnd: _ctx.dayCalendarEnd,
            auditCheckKey: _ctx.auditCheckKey,
            onCreated: _ctx.onZTillCalendarOpen
          }, null, 8, ["active", "companyId", "dayCalendarStart", "dayCalendarEnd", "auditCheckKey", "onCreated"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}